import React from 'react';
const awards = ['The Knot Best of Weddings — Hall of Fame', 'WeddingWire Couples’ Choice 2018–2024', 'Green America Certified'];
export function TestimonialBand() {
  return <section className="mt-20 bg-sand px-6 py-14" data-id="element-56" data-mp="12gr636vrgwvo">
      <figure className="mx-auto max-w-3xl text-center" data-id="element-57" data-mp="12ffyevz734za">
        <blockquote className="font-display text-2xl italic leading-snug text-ink md:text-[1.7rem]" data-id="element-58" data-mp="yfxea2f76xxi">
          “They provide nearly all the vendors for our wedding weekend, which made planning
          streamlined and far less stressful. Guests could not stop commenting on how gorgeous
          it all was.”
        </blockquote>
        <figcaption className="mt-4 font-sans text-[9px] font-medium uppercase tracking-[0.35em] text-ink/60" data-id="element-59" data-mp="jin898lbqk96">
          Heather L. — Bride
        </figcaption>
      </figure>
      <ul className="mx-auto mt-10 flex max-w-4xl flex-col items-center justify-center gap-3 md:flex-row md:gap-0" data-id="element-60" data-mp="2dwftu0gu9zxj">
        {awards.map((award, i) => <li key={award} className={`px-8 text-center font-sans text-[9px] font-medium uppercase tracking-[0.25em] text-ink/70 ${i > 0 ? 'md:border-l md:border-ink/25' : ''}`} data-id="element-61" data-mp="29sq6tfftbqem" data-mpi={i}>
            {award}
          </li>)}
      </ul>
    </section>;
}